import * as React from 'react';
import * as styles from './OptionListSelector.css';
import { IAIcon } from '../icon/Icon'
import { Helper } from '../../Helper';

export interface IOptionListSelectorProps {
  label?: string;
  options: { key: string; title?: string, icon?: string, description?: string, object?: any }[];
  selected?: string;
  highlightColor: string;
  disabled?: boolean;
  darkMode?: boolean;
  onChange: (option: { key: string; title?: string, icon?: string, description?: string, object?: any }) => void;
  style?: any;
}

export interface IOptionListSelectorState {
  selected: string;
}

export class IAOptionListSelector extends React.Component<IOptionListSelectorProps, IOptionListSelectorState> {

  constructor(props: IOptionListSelectorProps) {
    super(props);
    this.state = {
      selected: this.props.selected
    };
  }

  public componentWillReceiveProps(props: IOptionListSelectorProps): void {
    this.setState({ selected: props.selected });
  }

  private onChange(selectedOption:{ key: string; title?: string, icon?: string, description?: string, object?: any } ): void {
    this.setState({ selected: selectedOption.key });
    this.props.onChange(selectedOption);
  }

  public render(): JSX.Element {
    let options: JSX.Element[] = [];
    this.props.options.forEach((option: { key: string; title?: string, icon?: string, description?: string, object?: any }) => {
      options.push(
        <div
          key={`item_${option.key}`}
          onClick={() => this.props.disabled ? {} : this.onChange(option)}
          className={styles.IA_listItem}
          style={{
            border: this.state.selected === option.key ? `1px solid ${this.props.highlightColor}` : "1px solid transparent",
            backgroundColor: this.props.darkMode ? Helper.darkModeInputFieldBackgroundColor : "#f4f4f4",
            ...this.props.style
          }}
        >
          <div
            className={styles.IA_listItemIcon}
            style={{
              backgroundColor: this.props.darkMode ? "#6b6b6b" : "#e9e9e9"
            }}
          >
            <div>
              <IAIcon
                title={option.icon}
                size={40}
                color={this.props.highlightColor}
                style={{
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: 8,
                  textAlign: "center"
                }} />
            </div>
          </div>
          <div
            className={styles.IA_listItemTitle}
            style={{
              color: this.props.darkMode ? "#ffffff" : "#333333"
            }}>
            {option.title}
          </div>
          <div
            className={styles.IA_listItemDescription}
            style={{
              color: this.props.darkMode ? "#ffffff" : "#333333"
            }}>
            {option.title}
          </div>
        </div>
      );
    });
    return (
      <div
        className={(this.props.darkMode ? styles.IA_optionSelectorDarkMode : styles.IA_optionSelector)}
      >
        {this.props.label &&
          <label>{this.props.label}</label>
        }
        <div
          className={styles.IA_selections}
          style={{
            opacity: this.props.disabled ? 0.5 : 1
          }}
        >
          {options}
        </div>
      </div>
    );
  }

  
}